import { render, staticRenderFns } from "./TransactionProductDetail.vue?vue&type=template&id=3469211f&"
import script from "./TransactionProductDetail.vue?vue&type=script&lang=js&"
export * from "./TransactionProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports